import { useAuth } from '../contexts/AuthContext';
import { useState, useEffect, useRef } from 'react';
import MisCalificaciones from './ratings/MisCalificaciones';
import EditProfile from './EditProfile';
import { reviewsService } from '../services/reviewsService';
import './Feed.css';

const UserProfile = ({ onNavigate, openPlaylistModal }) => {
  const { user, userProfile, signOut, updateUserProfile } = useAuth();
  const [signingOut, setSigningOut] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [userStats, setUserStats] = useState({
    totalReviews: 0,
    totalRatings: 0,
    followers: 0
  });
  const menuRef = useRef(null);

  // Estados para la barra de navegación
  const [showFloatingActions, setShowFloatingActions] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Hook para detectar scroll y ocultar/mostrar navegación
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;

          // Solo ocultar si se ha hecho scroll hacia abajo más de 10px
          if (currentScrollY > lastScrollY && currentScrollY > 10) {
            setIsNavVisible(false);
          } else if (currentScrollY < lastScrollY) {
            setIsNavVisible(true);
          }

          setLastScrollY(currentScrollY);
          ticking = false;
        });

        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    const loadUserStats = async () => {
      if (user) {
        try {
          const reviews = await reviewsService.obtenerReviewsDeUsuario(user.id);
          setUserStats({
            totalReviews: reviews.length,
            totalRatings: reviews.length,
            followers: 0 // Puedes implementar el sistema de followers después
          });
        } catch (error) {
          console.error('Error cargando estadísticas:', error);
        }
      }
    };
    loadUserStats();
  }, [user]);

  // Cerrar menú al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  const handleSignOut = async () => {
    if (signingOut) return;

    setSigningOut(true);
    try {
      await signOut();
    } catch (error) {
      console.error('Error en handleSignOut:', error);
      setSigningOut(false);
    }
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  // Funciones para la barra de navegación
  const handleMouseEnter = () => {
    setShowFloatingActions(true);
  };

  const handleMouseLeave = () => {
    setShowFloatingActions(false);
  };

  const handlePlaylist = () => {
    if (openPlaylistModal) {
      openPlaylistModal(null);
    }
    setShowFloatingActions(false);
  };

  const handleLyrics = () => {
    alert("Lyrics - En desarrollo");
    setShowFloatingActions(false);
  };

  if (!user) {
    return <div>No hay usuario autenticado</div>;
  }

  if (!userProfile) {
    return <div>Cargando perfil...</div>;
  }


  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="bg-gradient-to-b from-purple-800 to-purple-900 p-8 rounded-lg mb-6 text-center">
        <h1 className="text-4xl font-bold text-white mb-2">Mi Perfil</h1>
        <p className="text-purple-200">Información de tu cuenta</p>
      </div>

      <div className="user-profile bg-gray-800 p-6 rounded-lg">
        {/* Header del perfil en layout horizontal */}
        <div className="profile-header" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '30px',
          marginBottom: '30px',
          position: 'relative'
        }}>
          {/* Avatar clickeable - Izquierda */}
          <div
            onClick={toggleMenu}
            style={{
              position: 'relative',
              cursor: 'pointer',
              flexShrink: 0,
              width: '100px',
              height: '100px'
            }}
          >
            {userProfile.avatar_url && userProfile.avatar_url.trim() !== '' ? (
              <>
                <img
                  src={userProfile.avatar_url}
                  alt="Avatar"
                  className="profile-avatar"
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '3px solid #8b5cf6',
                    transition: 'transform 0.2s',
                    display: 'block',
                    backgroundColor: '#4b5563'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const fallback = e.target.parentElement.querySelector('.avatar-fallback');
                    if (fallback) {
                      fallback.style.display = 'flex';
                    }
                  }}
                />
                <div
                  className="avatar-fallback"
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    backgroundColor: '#4b5563',
                    display: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '40px',
                    color: 'white',
                    border: '3px solid #8b5cf6',
                    position: 'absolute',
                    top: 0,
                    left: 0
                  }}
                >
                  {userProfile.username?.[0]?.toUpperCase() || 'U'}
                </div>
              </>
            ) : (
              <div
                className="avatar-fallback"
                style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  backgroundColor: '#4b5563',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '40px',
                  color: 'white',
                  border: '3px solid #8b5cf6',
                }}
              >
                {userProfile.username?.[0]?.toUpperCase() || 'U'}
              </div>
            )}
          </div>

          {/* Nombre completo y username - Centro */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            minWidth: '200px'
          }}>
            <h2
              onClick={toggleMenu}
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'white',
                margin: 0,
                cursor: 'pointer',
                transition: 'color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.color = '#a78bfa'}
              onMouseOut={(e) => e.target.style.color = 'white'}
            >
              {userProfile.full_name}
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#9ca3af',
              margin: 0
            }}>
              @{userProfile.username}
            </p>
          </div>

          {/* Separador vertical */}
          <div style={{
            width: '2px',
            height: '60px',
            backgroundColor: '#4b5563',
            flexShrink: 0
          }}></div>

          {/* Estadísticas - Derecha (horizontal) */}
          <div className="profile-stats" style={{
            display: 'flex',
            gap: '30px',
            flex: 1,
            justifyContent: 'flex-start'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#8b5cf6' }}>
                {userStats.totalReviews}
              </div>
              <div style={{ fontSize: '14px', color: '#9ca3af', whiteSpace: 'nowrap' }}>
                Reviews
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#8b5cf6' }}>
                {userStats.totalRatings}
              </div>
              <div style={{ fontSize: '14px', color: '#9ca3af', whiteSpace: 'nowrap' }}>
                Ratings
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#8b5cf6' }}>
                {userStats.followers}
              </div>
              <div style={{ fontSize: '14px', color: '#9ca3af', whiteSpace: 'nowrap' }}>
                Followers
              </div>
            </div>
          </div>

          {/* Menú desplegable */}
          {showMenu && (
            <div
              ref={menuRef}
              style={{
                position: 'absolute',
                top: '110px',
                left: '0',
                backgroundColor: '#1f2937',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
                zIndex: 100,
                minWidth: '200px',
                overflow: 'hidden',
              }}
            >
              <button
                onClick={() => {
                  setShowEditProfile(true);
                  setShowMenu(false);
                }}
                style={{
                  width: '100%',
                  padding: '12px 20px',
                  textAlign: 'left',
                  backgroundColor: 'transparent',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                  transition: 'background-color 0.2s',
                  borderBottom: '1px solid #374151'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#374151'}
                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                ✏️ Editar Perfil
              </button>
              <button
                onClick={() => {
                  handleSignOut();
                  setShowMenu(false);
                }}
                disabled={signingOut}
                style={{
                  width: '100%',
                  padding: '12px 20px',
                  textAlign: 'left',
                  backgroundColor: 'transparent',
                  color: signingOut ? '#9ca3af' : '#ef4444',
                  border: 'none',
                  cursor: signingOut ? 'not-allowed' : 'pointer',
                  fontSize: '16px',
                  transition: 'background-color 0.2s',
                }}
                onMouseOver={(e) => !signingOut && (e.target.style.backgroundColor = '#374151')}
                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                {signingOut ? '🔄 Cerrando sesión...' : '🚪 Cerrar Sesión'}
              </button>
            </div>
          )}
        </div>

        {/* SECCIÓN DE CALIFICACIONES DEL USUARIO */}
        <div style={{
          marginTop: '30px',
          borderTop: '2px solid #4b5563',
          paddingTop: '30px'
        }}>
          <h3 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: 'white',
            marginBottom: '20px'
          }}>
            Mis Reviews y Calificaciones
          </h3>
          <MisCalificaciones usuarioId={user.id} />
        </div>
      </div>

      {/* Modal de editar perfil */}
      {showEditProfile && (
        <EditProfile
          onClose={() => setShowEditProfile(false)}
          onSave={() => {
            // Recargar estadísticas después de guardar
            reviewsService.obtenerReviewsDeUsuario(user.id).then(reviews => {
              setUserStats({
                totalReviews: reviews.length,
                totalRatings: reviews.length,
                followers: 0
              });
            });
          }}
        />
      )}

      {/* Barra de navegación flotante */}
      <div className={`floating-nav ${!isNavVisible ? 'hidden' : ''}`}>
        <button
          className="nav-icon"
          onClick={() => onNavigate && onNavigate('home')}
        >
          <span className="icon">🏠</span>
          <span className="icon-label">Inicio</span>
        </button>

        <button
          className="nav-icon"
          onClick={() => onNavigate && onNavigate('search')}
        >
          <span className="icon">🔍</span>
          <span className="icon-label">Buscar</span>
        </button>

        <div
          className="nav-center-container"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {showFloatingActions && (
            <div className="floating-actions">
              <button
                className="floating-action-btn"
                onClick={handlePlaylist}
              >
                <span className="floating-action-icon">🎵</span>
                <span className="floating-action-label">Playlist</span>
              </button>
              <button
                className="floating-action-btn"
                onClick={handleLyrics}
              >
                <span className="floating-action-icon">🎤</span>
                <span className="floating-action-label">Lyrics</span>
              </button>
            </div>
          )}

          <button
            className={`nav-icon nav-icon-add ${showFloatingActions ? 'rotated' : ''}`}
          >
            <span className="icon icon-plus">➕</span>
          </button>
        </div>

        <button
          className="nav-icon"
          onClick={() => alert("Notificaciones próximamente")}
        >
          <span className="icon">❤️</span>
          <span className="icon-label">Likes</span>
        </button>

        <button
          className="nav-icon"
          onClick={() => onNavigate && onNavigate('profile')}
        >
          <span className="icon">👤</span>
          <span className="icon-label">Mi Perfil</span>
        </button>
      </div>
    </div>
  );
};

export default UserProfile;